export const driversSummary = {
    distance: {
        text: <span><span className={'green-color'}>30k</span>/28k</span>,
        name: 'Kms Travelled',
        color: 'light-color'
    },
    counts: {
        "currentPeriod": {
            "count": 68,
            "dates": "2023-10-17 - 2023-10-25"
        },
        "lastPeriod": {
            "count": 39,
            "dates": "2023-10-17 - 2023-10-17"
        }
    },
    alerts: [
        {
            "id": 3,
            "name": "NO SEATBELT",
            "parent": 2,
            "value": 469,
            "diff": 135.68,
            "tooltip_name": "No Seatbelt",
            "value_prev": 199,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "469"
        },
        {
            "id": 4,
            "name": "DRINKING",
            "parent": 2,
            "value": 5,
            "diff": -28.57,
            "tooltip_name": "Drinking",
            "value_prev": 7,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "5"
        },
        {
            "id": 5,
            "name": "DROWSY",
            "parent": 2,
            "value": 13,
            "diff": 1200,
            "tooltip_name": "Drowsy",
            "value_prev": 1,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "13"
        },
        {
            "id": 6,
            "name": "TEXTING",
            "parent": 2,
            "value": 1,
            "diff": -66.67,
            "tooltip_name": "Texting",
            "value_prev": 3,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "1"
        },
        {
            "id": 7,
            "name": "ON PHONE",
            "parent": 2,
            "value": 40,
            "diff": 66.67,
            "tooltip_name": "On Phone",
            "value_prev": 24,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "40"
        },
        {
            "id": 8,
            "name": "GAZE DOWN",
            "parent": 2,
            "value": 195,
            "diff": 786.36,
            "tooltip_name": "Gaze Down Distraction",
            "value_prev": 22,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "195"
        },
        {
            "id": 9,
            "name": "SMOKING",
            "parent": 2,
            "value": 1,
            "diff": 100,
            "tooltip_name": "Smoking",
            "value_prev": 0,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "1"
        },
        {
            "id": 10,
            "name": "DISTRACTED",
            "parent": 2,
            "value": 575,
            "diff": 207.49,
            "tooltip_name": "Distracted",
            "value_prev": 187,
            "current_to": "2023-10-25",
            "prev_to": "2023-09-30",
            "value_str": "575"
        },
        {
            "id": 1,
            "name": "parent"
        },
        {
            "name": "DMS",
            "id": 2,
            "parent": 1
        }
    ]
};

export const tripSummary = {
    distance: {
        text: <span><span className={'green-color'}>30k</span>/28k</span>,
        name: 'Kms Travelled',
        color: 'light-color'
    },
    counts: {},
    alerts: []
};

export const driverSummary = [
    {
        text: <span><span className={'green-color'}>30k</span>/28k</span>,
        name: 'Kms Travelled',
        color: 'light-color'
    },
    {
        text: <span><span className={'green-color'}>43k</span>/40k</span>,
        name: 'No of Trips',
        color: 'light-color'
    },
    {
        text: '649',
        name: 'FCW',
        color: 'green-color'
    },
    {
        text: '189',
        name: 'PCW',
        color: 'red-color'
    },
    {
        text: '1.6k',
        name: 'LDW',
        color: 'green-color'
    },
    {
        text: 738,
        name: 'HA',
        color: 'red-color'
    },
    {
        text: 699,
        name: 'HB',
        color: 'red-color'
    },
    {
        text: 451,
        name: 'DIS',
        color: 'green-color'
    },
    {
        text: '2k',
        name: 'HMW',
        color: 'red-color'
    },
    {
        text: 201,
        name: 'DRW',
        color: 'green-color'
    },
];

export const driverList = [
    {
        img: 'user-1',
        name: 'Babu K',
        rating: 4.8,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 24609,
        action: '',
    },
    {
        img: 'user-2',
        name: 'Ramesh J',
        rating: 4.6,
        alertness: 'Good',
        alerts: 1,
        criticalAlerts: 2,
        id: 68858,
        action: 'Coaching',
    },
    {
        img: 'user-3',
        name: 'Sundarajan',
        rating: 4.7,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 94038,
        action: '',
    },
    {
        img: 'user-4',
        name: 'Antony ',
        rating: 4.5,
        alertness: 'Ok',
        alerts: 0,
        criticalAlerts: 3,
        id: 22010,
        action: '',
    },
    {
        img: 'user-1',
        name: 'Babu K',
        rating: 4.8,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 24601,
        action: '',
    },
    {
        img: 'user-2',
        name: 'Ramesh J',
        rating: 4.6,
        alertness: 'Good',
        alerts: 1,
        criticalAlerts: 2,
        id: 68853,
        action: 'Coaching',
    },
    {
        img: 'user-3',
        name: 'Sundarajan',
        rating: 4.7,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 94032,
        action: '',
    },
    {
        img: 'user-4',
        name: 'Antony ',
        rating: 4.5,
        alertness: 'Ok',
        alerts: 0,
        criticalAlerts: 3,
        id: 22016,
        action: '',
    }
]
